export default __webpack_public_path__ + "static/app-features-4--mobile-5c41e3053c7e34693deef9cd529a69d3.png";